import { UserReportReasonEnum } from '@colonist/game-base-types';
export const reportReasonIdMap = {
    toReasonId: (reason)=>String(reason),
    fromReasonId: (reasonId)=>Number(reasonId)
};
const reportReasonLabels = {
    [UserReportReasonEnum.CheatingWithAnotherPlayer]: {
        key: 'strings:popups.reportPopup.reasons.cheatingWithAnotherPlayer'
    },
    [UserReportReasonEnum.AbusingChat]: {
        key: 'strings:popups.reportPopup.reasons.abusingChat'
    },
    [UserReportReasonEnum.InappropriateUsername]: {
        key: 'strings:popups.reportPopup.reasons.inappropriateUsername'
    },
    [UserReportReasonEnum.WastingTime]: {
        key: 'strings:popups.reportPopup.reasons.wastingTime'
    },
    [UserReportReasonEnum.Griefing]: {
        key: 'strings:popups.reportPopup.reasons.griefing'
    },
    [UserReportReasonEnum.ThrowingTheGame]: {
        key: 'strings:popups.reportPopup.reasons.throwingTheGame'
    }
};
const reportReasonValues = Object.values(UserReportReasonEnum).filter((value)=>typeof value == 'number');
export const reportReasons = reportReasonValues.map((reason)=>({
        id: reportReasonIdMap.toReasonId(reason),
        label: reportReasonLabels[reason]
    }));
